import { Typography } from '@material-ui/core'

import { useStyles } from './styles'

export default function ListHeader() {
  const classes = useStyles()

  return (
    <div className={classes.listHeader}>
      <Typography>Nome do talhão</Typography>
      <Typography>Área</Typography>
      <Typography>Diagnósticos</Typography>
      <div />
    </div>
  )
}
